import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/futbol': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M483.8 179.4C449.8 74.6 352.6 8 248.1 8 222.7 8 196.9 11.9 171.4 20.2 41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504 273.3 504 299.1 500.1 324.6 491.8 454.8 449.5 526.1 309.6 483.8 179.4zM409.3 373.1L357.1 379.5 313.4 318.6 337.8 243.4 408.9 221.3 447.8 257.7C447.6 288.4 440.4 318.8 426.1 346.9 421.4 356.2 415.4 364.7 409.3 373.1zM409.3 137.7L398.9 190.8 328.2 212.8 264 166.3V92.5L311.4 66.3C350.6 79.3 384.8 104.3 409.3 137.7zM184.9 66.4L232 92.5V166.3L167.8 212.8 97.2 190.8 87.1 138.3C111.4 104.9 145 79.7 184.9 66.4zM139 379.5L85.9 373C71.5 352.9 48.6 313.4 48.1 257.7L87.1 221.3 158.2 243.5 182.5 317.8 139 379.5zM187.2 446.5L164.8 398.4 208.4 336.7H287L331.3 398.4 308.9 446.5C302.7 448.3 251.3 466.9 187.2 446.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/futbol.js
// module id = Ot7V
// module chunks = 144